/**
 * # Get Sibling Before
 * Get a nearest sibling before the given element which matches
 * the given query selector.
 *
 * @param {Element} el
 * @param {String} query
 * @return {Element|Null}
 *
 */

import matches from "../dom/matches";

function getSiblingBefore(el, query) {
  // @TODO: utils/traversal methods should be rewritten to Typescript
  while ((el = el.previousElementSibling)) {
    if (matches(el, query)) {
      return el;
    }
  }

  return null;
}

export default getSiblingBefore;
